import * as React from 'react'

function PageLink({ number, pLink, currentPage, handlePageChange }) {
    if (pLink == null) {
        return (
            <li key={number} className="page-item disabled" >
                <label className="page-link">{number}</label>
            </li>
        )
    }
    else if (number == currentPage) {
        return (

            <li key={number} className="page-item active" onClick={() => handlePageChange(number)}>
                <label className="page-link">{number}</label>
            </li>

        )
    }
    else {
        return (

            <li key={number} className="page-item" onClick={() => handlePageChange(number)}>
                <label className="page-link">{number}</label>
            </li>

        )
    }
}

const Pagination = ({ pageLimit, currentPage, setCurrentPage, reLoadCourses, props }) => { //totalCount is count variable received from api
    const pageNumbers = [];
    const paginationInfo = props.paginationInfo;
    const handlePageChange = (pageNumber) => {
        if (pageNumber == 'Next') {
            pageNumber = currentPage + 1;
        }
        if (pageNumber == 'Previous') {
            pageNumber = currentPage - 1;
        }
        setCurrentPage(pageNumber);
        reLoadCourses(undefined, pageNumber)
    }
    for (let i = 1; i <= Math.ceil(paginationInfo.totalCourses / pageLimit); i++) {
        pageNumbers.push(i);
    }
    return (

        <nav className="mx-auto mt-3 col-md-12">
            <ul className="pagination">
                <PageLink number='Previous' pLink={props.paginationInfo.prevLink} currentPage={currentPage} handlePageChange={handlePageChange} />
                {pageNumbers.map(number => {
                    if ((number >= currentPage - 6 && number <= currentPage + 4) || (currentPage <= 5 && number <= 10)) {
                        return <PageLink number={number} pLink={number} currentPage={currentPage} handlePageChange={handlePageChange} />
                        // <li key={number} className="page-item">
                        // <a href="!#" className="page-link">{number}</a>
                        // </li>
                    }
                })}
                {/* <li key='+1' className='page-item' onClick={(number) => handlePageChange(number)}><a href="!#" className="page-link"> Next </a></li> */}
                <PageLink number='Next' pLink={props.paginationInfo.nextLink} currentPage={currentPage} handlePageChange={handlePageChange} />
            </ul>

        </nav>
    )
}


export default Pagination;